// @flow

import { handleMapRequest } from '../phasedActionHelpers';

import type { LoadEpochAction } from '../../actions/epoch';

export type State = {
  +[key: string]: {|
    +loading: boolean,
    +loaded: boolean,
    +entities: string,
  |},
  loading: boolean,
};

const initialState = {
  loading: false,
};

export default function epochs(state: State = initialState, action: LoadEpochAction): State {
  if (action.type === 'FETCH_EPOCH' && action.cacheId) {
    return handleMapRequest(state, action, action.cacheId);
  }

  return state;
}
